
// export const BE_URL = 'http://localhost:3500'
// export const FE_URL = 'http://localhost:3000'
// export const TIME_OF_LOADING = 300

export const BE_URL = 'https://lucia-restaurant.herokuapp.com'
export const FE_URL = 'https://lucia-restaurant-youssef.netlify.app/'
export const TIME_OF_LOADING = 3000